import { useMemo } from "react";

const HIDE_VALUE_COLUMNS = ["currentValPacing", "needed", "progress"];

export const useSortedGoals = (goals, sortConfig) => {
  return useMemo(() => {
    if (!sortConfig.key || !sortConfig.direction) return goals;

    return [...goals].sort((a, b) => {
      if (a.active && !b.active) return -1;
      if (!a.active && b.active) return 1;

      const aWithoutValue = a.isPercentageValue && HIDE_VALUE_COLUMNS.includes(sortConfig.key);
      const bWithoutValue = b.isPercentageValue && HIDE_VALUE_COLUMNS.includes(sortConfig.key);

      if (aWithoutValue && !bWithoutValue) return 1;
      if (!aWithoutValue && bWithoutValue) return -1;
      if (aWithoutValue && bWithoutValue) return 0;

      const valueA = a?.[sortConfig.key];
      const valueB = b?.[sortConfig.key];

      if (valueA == null || valueB == null) return 0;
      return sortConfig.direction === "asc" ? valueA - valueB : valueB - valueA;
    });
  }, [goals, sortConfig]);
};
